import { Component, DestroyRef, inject, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { CatalogFilter } from 'src/app/common/CatalogFilter';
import { ProductCategory } from 'src/app/common/ProductCategory';
import { ProductCategoryService } from 'src/app/services/product-category.service';

@Component({
    imports: [KENDO_DROPDOWNS, FormsModule],
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html'
})
export class CatalogSearchComponent implements OnInit {
  private productCategoryService = inject(ProductCategoryService);
  private route = inject(ActivatedRoute);

  private destroyRef = inject(DestroyRef);

  public product = '';
  public productCategories: ProductCategory[] = [];
  // #178: the dropdown renders `name` now (backend #688 resolves it per language), so the
  // synthetic "all" row carries one too.
  public defaultProductCategoryItem: ProductCategory = {
    id: null,
    shortName: $localize`Alle Kategorien`,
    description: $localize`Alle Kategorien`,
    name: $localize`Alle Kategorien`,
  };

  public catalogFilter: CatalogFilter = new CatalogFilter();

  readonly searchCriteria = output<CatalogFilter>();

  emitSearch() {
    this.catalogFilter.name = this.product || null;
    this.catalogFilter.isSearchActive = true;
    this.searchCriteria.emit(this.catalogFilter);
  }

  ngOnInit(): void {
    this.productCategoryService.get().subscribe((res: ProductCategory[]) => {
      this.productCategories = [this.defaultProductCategoryItem].concat(res);
    });

    // Mirror the active search from the URL so a reload / shared link shows the current
    // term + category. The bar doesn't run the search itself (SearchComponent does) — it
    // just stays in sync, so the "Suchen" button always re-emits the real filter.
    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => this.applyParams(params));
  }

  public productCategoryChanged(productCategory: ProductCategory) {
    this.catalogFilter.categoryId = productCategory.id;
    this.emitSearch();
  }

  private applyParams(params: ParamMap): void {
    this.catalogFilter.name = params.get('name');
    this.catalogFilter.categoryId = params.get('categoryId');
    this.catalogFilter.productSkuId = params.get('productSkuId');
    this.product = this.catalogFilter.name ?? '';
  }
}
